/* Keep measurements in this tab, rather than in shareable URLs. */
(() => {
  const root = document.querySelector('#shappa-chair-finder');
  if (!root) return;
  const form = root.querySelector('#fit-form');
  // Keep validation copy in the storefront language, not the browser UI language.
  form.addEventListener('invalid', event => {
    const input = event.target;
    input.setCustomValidity('');
    const validity = input.validity;
    let message = '';
    if (input.name === 'gender' && validity.valueMissing) {
      message = 'Please select your gender.';
    } else if (input.name === 'height' || input.name === 'weight') {
      const unit = input.name === 'height' ? 'cm' : 'kg';
      if (validity.valueMissing || validity.badInput) {
        message = `Please enter your ${input.name} in ${unit}.`;
      } else if (validity.rangeUnderflow || validity.rangeOverflow) {
        message = `Please enter a ${input.name} between ${input.min} and ${input.max} ${unit}.`;
      } else if (validity.stepMismatch) {
        message = input.name === 'height' ? 'Please enter your height in whole centimetres.' : 'Please enter your weight with up to one decimal place.';
      }
    } else if (!validity.valid) {
      message = 'Please complete this field.';
    }
    input.setCustomValidity(message);
  }, true);
  ['input', 'change'].forEach(type => form.addEventListener(type, event => {
    if (typeof event.target.setCustomValidity === 'function') event.target.setCustomValidity('');
  }));
  form.addEventListener('reset', () => {
    Array.from(form.elements).forEach(input => {
      if (typeof input.setCustomValidity === 'function') input.setCustomValidity('');
    });
  });
  const key = 'shappa-chair-fit-transfer-v1';
  const fields = ['gender', 'height', 'weight', 'hours', 'space', 'priority', 'budget'];
  const home = root.classList.contains('chair-finder--home');
  if (home) {
    const type = form.querySelector('#chair-type');
    function syncType() {
      const office = type.value === 'office';
      ['hours', 'space', 'priority'].forEach(name => {
        const input = form.elements.namedItem(name);
        input.disabled = office;
        input.closest('label').hidden = office;
      });
    }
    type.addEventListener('change', syncType);
    form.addEventListener('reset', () => requestAnimationFrame(syncType));
    syncType();
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const kind = type.value === 'office' ? 'office' : 'ergonomic';
      const values = Object.fromEntries(fields.map(name => [name, form.elements.namedItem(name)?.value || '']));
      const destination = new URL(kind === 'office' ? '/collections/office-chair' : '/collections/ergonomic-chairs', location.origin);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (/^\d+$/.test(preview || '')) destination.searchParams.set('preview_theme_id', preview);
      try { sessionStorage.setItem(key, JSON.stringify({kind, values, expires: Date.now() + 30 * 60 * 1000})); }
      catch (_) {
        // Fragment fallback stays out of server requests when storage is unavailable.
        destination.hash = 'fit=' + encodeURIComponent(JSON.stringify({kind, values}));
      }
      if (!destination.hash) destination.hash = 'recommendation';
      location.assign(destination.href);
    });
    return;
  }
  document.addEventListener('DOMContentLoaded', () => {
    let pending;
    try {
      if (location.hash.startsWith('#fit=')) {
        pending = JSON.parse(decodeURIComponent(location.hash.slice(5)));
        history.replaceState(null, '', location.pathname + location.search + '#recommendation');
      } else {
        pending = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (pending?.expires < Date.now()) { sessionStorage.removeItem(key); return; }
      }
      const kind = root.dataset.chairKind || 'ergonomic';
      if (!pending || pending.kind !== kind) return;
      try { sessionStorage.removeItem(key); } catch (_) {}
      fields.forEach(name => {
        const input = form.elements.namedItem(name);
        const value = pending.values?.[name];
        if (!input || typeof value !== 'string' || value.length > 30) return;
        if (input.tagName === 'SELECT' && !Array.from(input.options).some(option => option.value === value)) return;
        input.value = value;
      });
      const result = root.querySelector('#recommendation');
      if (result) result.style.scrollMarginTop = `${Math.ceil(document.querySelector('header')?.offsetHeight || 100) + 16}px`;
      if (form.checkValidity()) form.requestSubmit();
    } catch (_) { /* Direct visits keep the normal blank form. */ }
  }, {once: true});
})();
